import SidebarBookingsInternalMessagesController from 'uplisting-frontend/pods/-sidebar/bookings/internal-messages/controller';

export default class ProtectionOverviewBookingsInternalMessagesController extends SidebarBookingsInternalMessagesController {}
